"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montesegale": {
    "44baa55f": [{
      "hkey": "eb7cb3d4",
      "slug": "bregne",
      "name": "Bregne",
      "primary": true,
      "skipSearch": false
    }],
    "bregni": [{
      "hkey": "eb7cb3d4",
      "slug": "bregne",
      "name": "Bregne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "feac291c": [{
      "hkey": "62dd528f",
      "slug": "case-del-molino-languzzano",
      "name": "Case del Molino-Languzzano",
      "primary": true,
      "skipSearch": false
    }],
    "case-del-molino": [{
      "hkey": "62dd528f",
      "slug": "case-del-molino-languzzano",
      "name": "Case del Molino-Languzzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montesegale"
    }],
    "cbbbdf5c": [{
      "hkey": "22c96855",
      "slug": "frascate-montesasso",
      "name": "Frascate-Montesasso",
      "primary": true,
      "skipSearch": false
    }],
    "frascate": [{
      "hkey": "22c96855",
      "slug": "frascate-montesasso",
      "name": "Frascate-Montesasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "16f8bb5a": [{
      "hkey": "62dd528f",
      "slug": "case-del-molino-languzzano",
      "name": "Case del Molino-Languzzano",
      "primary": true,
      "skipSearch": false
    }],
    "languzzano": [{
      "hkey": "62dd528f",
      "slug": "case-del-molino-languzzano",
      "name": "Case del Molino-Languzzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montesegale"
    }],
    "9bbbea8d": [{
      "hkey": "f1ea7f59",
      "slug": "montesegale",
      "name": "Montesegale",
      "primary": true,
      "skipSearch": false
    }],
    "san-damiano": [{
      "hkey": "f1ea7f59",
      "slug": "montesegale",
      "name": "Montesegale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d935690c": [{
      "hkey": "1b4fe0e7",
      "slug": "sanguignano",
      "name": "Sanguignano",
      "primary": true,
      "skipSearch": false
    }],
    "san-guignano": [{
      "hkey": "1b4fe0e7",
      "slug": "sanguignano",
      "name": "Sanguignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;